// extracted by mini-css-extract-plugin
export var active = "_g2-2";
export var recordingDot = "_g2-1";
export var recordingIndicator = "_g2-0";